import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { AppConfig } from '../Shared/configs/app.config';

@Injectable({
  providedIn: 'root'
})
export class DealerAdviceService {

  constructor(
    private dataProvider: DataService
  ) { }

  public getDealerAdviceMasterData() {
    return this.dataProvider.Get(AppConfig.GET_DEALER_ADVICE_MASTER_DATA_URL);
  }

  getDealerScreenView() {
    return this.dataProvider.Get(AppConfig.GET_DEALER_SCREEN_MASTER_VIEW_URL);
  }

}
